/* Imán de tu recorrido (ficha): si la casilla está marcada, añade el imán justo antes de añadir la pieza. */
(function () {
  var cb = document.querySelector('[data-at-iman-ficha]');
  if (!cb || window.__atImanFicha) return;
  window.__atImanFicha = true;
  var VID = Number(cb.getAttribute('data-variant'));
  var MODELO = cb.getAttribute('data-modelo') || '';
  var ADD = cb.getAttribute('data-add-url');
  var CHANGE = cb.getAttribute('data-change-url');
  var ALLOW = /^properties\[(Carrera|Tipo de recorrido|Color de la ruta|Color del mapeado|Enlace del recorrido|_Recorrido|_Datos GPX|_Encuadre)\]$/;
  var orig = window.fetch;
  function token() { return Date.now().toString(36) + Math.random().toString(36).slice(2, 6); }
  window.fetch = function (input, init) {
    var self = this, args = arguments;
    try {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var body = init && init.body;
      var vid = body && typeof body.get === 'function' ? Number(body.get('id')) : 0;
      if (url.indexOf('/cart/add') > -1 && typeof FormData !== 'undefined' && body instanceof FormData && vid && vid !== VID) {
        var t = token();
        body.set('properties[_Id pieza]', t);
        if (cb.checked) {
          var mag = { id: VID, quantity: Number(body.get('quantity')) || 1, properties: {} };
          body.forEach(function (v, k) {
            if (ALLOW.test(k) && typeof v === 'string' && v) {
              var n = k.slice(11, -1);
              mag.properties[n] = (n === 'Tipo de recorrido' && v === 'Ciudad con edificios') ? 'Ciudad sin edificios' : v;
            }
          });
          mag.properties['_Id pieza'] = t;
          mag.properties['_Imán de'] = MODELO;
          return orig(ADD, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [mag] })
          })
            .then(function (r) { return r.json(); })
            .catch(function () { return null; })
            .then(function (m) {
              return orig.apply(self, args).then(function (res) {
                try {
                  res.clone().json().then(function (j) {
                    var key = m && m.items && m.items[0] && m.items[0].key;
                    if (j && j.status && key) {
                      orig(CHANGE, {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                        body: JSON.stringify({ id: key, quantity: 0 })
                      });
                    }
                  }).catch(function () {});
                } catch (e) {}
                return res;
              });
            });
        }
      }
    } catch (e) {}
    return orig.apply(self, args);
  };
})();